module.exports = __webpack_public_path__ + "static/media/Passport Back.dd8b66bd.jpg";